import { Component } from '@angular/core';

@Component({
  selector: 'app-account-panel',
  templateUrl: './account-panel.component.html'
})
export class AccountPanelComponent {
}
